import axios from "axios";
import Swal from "sweetalert2";

export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";
export const FILE_BASE_URL = process.env.VUE_APP_FILE_BASE_URL || "https://sanskritirdapoon.in";

// Authorization header for the logged-in user (empty object for guests)
export function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Axios instance for calls that need login (admin panel, uploads, etc.)
const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() };
  return config;
});

let sessionAlertShown = false;
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    if ((status === 401 || status === 403) && !sessionAlertShown) {
      sessionAlertShown = true;
      const expired = status === 401;
      if (expired) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
      Swal.fire({
        icon: "warning",
        title: expired ? "Session expired" : "Access denied",
        text: expired ? "Please log in again to continue." : err.response?.data?.error || "You don't have permission to do that.",
        confirmButtonColor: "#BF3131",
      }).then(() => {
        sessionAlertShown = false;
        if (expired) window.location.href = "/login";
      });
    }
    return Promise.reject(err);
  }
);

export default api;

// Readable message from an axios error
export function errorMessage(err, fallback = "Something went wrong") {
  return err?.response?.data?.error || err?.message || fallback;
}

/*
 * Open a newspaper/magazine PDF. The server checks access and returns a
 * short-lived link, so paid PDFs are never publicly downloadable.
 * kind: 'newspaper' | 'magazine'
 */
export async function openPdf(kind, id) {
  const res = await axios.post(`${API_BASE_URL}/${kind}s/${id}/download-link`, null, { headers: authHeaders() });
  const link = document.createElement("a");
  link.href = `${FILE_BASE_URL}${res.data.url}`;
  link.target = "_blank";
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
